<script type="text/javascript">
	import { EventBus } from '../../../../../public-app'
	import AccountOverview from '../../../../../website-views/account/overview'
	import Login from "../../../../../website-views/account/onpageLogin";
	export default{
		components: {AccountOverview, Login},
		data(){
			return{
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
				updateAvatar: false,
				breadcrumbs: [],
				cardExpanded: '',
				orders: '',
				bread: {
					title: '',
					link: '',
					id: 1,
				},
				account_tabs: [
					{
						title: 'Overview',
						link: '',
						icon: '',
						active: true,
						id: 1,
					},
					{
						title: 'Addresses',
						link: '/addresses',
						icon: '',
						active: false,
						id: 2,
					},
					{
						title: 'Orders',
						link: '/orders',
						icon: '',
						active: false,
						id: 3,
					},
					/**{
						title: 'Payment Details',
						link: '',
						icon: '',
						active: false,
						id: 3,
					},**/
					{
						title: 'Messages',
						link: '/messages',
						icon: '',
						active: false,
						id: 3,
					},
					{
						title: 'Wishlist',
						link: '/wishlist',
						icon: '',
						active: false,
						id: 3,
					}
				]
			}
		},
		props: {
			user: {
				type: Object
			}
		},
		mounted() {
			var url = location.hash;
        		if(url.search("uid=") > 0){
             			 var uid = url.substring(0, url.lastIndexOf("?")).replace('#', '').replace('?', '');
             			 this.cardExpanded = uid;
             	 }else{
        		 	this.cardExpanded = this.$route.params.child;
        			}
			this.breadcrumbs = this.$route.path.split('/');
			this.breadcrumbs[1] = this.breadcrumbs[1].replaceAll('-',' ');
				if(this.breadcrumbs.length > 0){
				this.title = this.breadcrumbs[this.breadcrumbs.length - 1];
				this.breadcrumbs[0] = "Home";
				}
				
			
		},
		methods: {
			removeHash () { 
			    var scrollV, scrollH, loc = window.location;
			    if ("pushState" in history)
			        history.pushState("", document.title, loc.pathname + loc.search);
			    else {
			        // Prevent scrolling by storing the page's current scroll offset
			        scrollV = document.body.scrollTop;
			        scrollH = document.body.scrollLeft;

			        loc.hash = "";

			        // Restore the scroll offset, should be flicker free
			        document.body.scrollTop = scrollV;
			        document.body.scrollLeft = scrollH;
			    }
			}
		},
		watch: {
        $route() {
        	this.$nextTick(() => {
        		var url = location.hash;
        		if(url.search("uid=") > 0){
             			 var uid = url.substring(0, url.lastIndexOf("?")).replace('#', '').replace('?', '');
             			 this.cardExpanded = uid;
             	 }else{
        		 	this.cardExpanded = this.$route.params.child;
        			}
        		 //this.cardExpanded = this.$route.params.child;

        		});
        	}
        }
		
	}

</script>
<template>
	<div>
		<section >
		  <div class="container-fluid" style="background: #fff">
		    <!--<PageHeader :title="title" :items="items" />-->
		   
		    <b-row class="my-4 py-4">
		    	<b-col md="12">
		    	<b-row class="pb-5" v-if="user == ''">
			    		<b-col md="6" class="mx-auto">
				    		<Login :submit-url="'http://website.'+domain.domain_key+'.gemesys.co.uk/account/login'" auth-error="">
				             <input type="hidden" name="_token" :value="csrf">
				        		</Login>
	        		</b-col>
		    	</b-row>
		    	<b-row class="pb-5" v-else>
		    		<b-col md="9" class="profile-user-wid">
		      	<AccountOverview :user="user" :cardExpanded="cardExpanded"></AccountOverview>
		        </b-col>
		        <b-col md="3" style="min-height: 500px;">
		        	<div class="avatar-xl profile-user-wid mb-2 mr-auto w-100">
		        		<b-card class="border-radius-1em">
		        			<div class="avatar-xl profile-user-wid mb-2 mx-auto position-relative" @mouseenter="updateAvatar = !updateAvatar" @mouseleave="updateAvatar = !updateAvatar">
                  <img
                  	v-if="user.avatar" :src="storageurl + user.avatar"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                   <img
                  	v-else 
                    src="/images/product-placeholder.png"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                <div class="avatar-xl bg-soft avatar-title top-0 mb-2 mx-auto position-absolute rounded-circle w-100 opacity-75 text-uppercase font-size-10" v-if="updateAvatar == true">
                	
                	Update Avatar
                </div>
                </div>

		        			<h5 class="text-center" v-if="user">{{user.name}} {{user.lastname}}</h5>
		        			<p  class="text-muted mb-4 text-center">
			                    <a href="javascript:;">{{user.email}}</a>
			                  </p>
			            
		        			<router-link v-for="tab in account_tabs" class="btn btn-outline-light btn-rounded btn-block mb-2" :to="'/account'+tab.link" >{{tab.title}}<i :class="tab.icon"></i></router-link>

		        			<a class="btn btn-danger btn-rounded btn-block mt-3 mb-2" href="/my-account/logout" >Logout<i class="bx bx-power-off"></i></a>
		        		
		        		</b-card>
		        	</div>
		        </b-col>
		    	</b-row>
		    	</b-col>
		  	</b-row>
		    <!-- end row -->
		  </div>
		</section>
</div>
</template>